import React from 'react'
import { string, func } from 'prop-types'
import { Toaster } from '@cobalt/cobalt-react-components'

const DELAY = 4000

const ToastError = ({ title, onDismiss }) => (
  <Toaster>
    <Toaster.Toast
      dismissDelay={DELAY}
      id="toast-error"
      key="toast-error"
      danger
      dismissible
      onDismiss={onDismiss}
    >
      <Toaster.Toast.Title>{title}</Toaster.Toast.Title>
    </Toaster.Toast>
  </Toaster>
)

ToastError.propTypes = {
  title: string.isRequired,
  onDismiss: func.isRequired
}

export default ToastError
